import * as actionTypes from "./actionTypes";
import {
  getAccumulatorsSettingsAPI,
  deleteAccumulatorsSettingsAPI,
  createAccumulatorsSettingsAPI,
  updateAccumulatorsSettingsAPI,
} from "@icarius-connection/api";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString, getErrorStringFromServerError } from "@icarius-localization/strings";

const errorHandler = (e, dispatch) => {
  let errorString = "";
  switch (e.response?.data?.status) {
    case "INVALID_DATA":
    case "VALIDATION_ERROR":
      errorString = getLocalizedString("validationError");
      break;
    case "DUPLICATED_DATA":
      errorString = getLocalizedString("cannotExistMoreThanOneAccumulatorWithSameCodeOrName");
      break;
    default:
      errorString = getErrorStringFromServerError(e);
      break;
  }
  dispatch(openSnackbarAction({ msg: errorString, severity: "error" }));
}

export const getAccumulatorsAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET });
  try {
    let response = await getAccumulatorsSettingsAPI();

    let data = response.data && response.data.result;
    let months = response.data && response.data.monthsList;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_FULFILLED,
      payload: { data, months },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const deleteAccumulatorAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: actionTypes.DELETE });
  try {
    let response = await deleteAccumulatorsSettingsAPI(dataToSend);

    let data = response.data && response.data.result;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.DELETE_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.DELETE_FULFILLED,
      payload: { data },
    });

    dispatch(openSnackbarAction({ msg: getLocalizedString("accumulatorDeletedOk"), severity: "success" }));
    return response;
  } catch (e) {
    if(e.response.data.error === "ACCUM_IN_USE"){
      dispatch(openSnackbarAction({ msg: getLocalizedString("cannotDeleteAccumulatorBecauseItIsUsedInFormulas"), severity: "error" }));
    }else{
      dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));  
    }
    dispatch({ type: actionTypes.DELETE_REJECTED, payload: e });
  }
};

export const createAccumulatorAction = (permission) => async (dispatch) => {
  dispatch({ type: actionTypes.CREATE });
  try {
    let response = await createAccumulatorsSettingsAPI(permission);

    let data = response.data && response.data.result;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.CREATE_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.CREATE_FULFILLED,
      payload: { data },
    });

    dispatch(openSnackbarAction({ msg: getLocalizedString("accumulatorCreatedOk"), severity: "success" }));
    return response;
  } catch (e) {
    if(e.response.data.error === "DUPLICATED_DATA"){
      dispatch(openSnackbarAction({ msg: getLocalizedString("cannotExistMoreThanOneAccumulatorWithSameCodeOrName"), severity: "error" }));
    }else{
      errorHandler(e, dispatch);
    }
    dispatch({ type: actionTypes.CREATE_REJECTED, payload: e });
    
  }
};

export const modifyAccumulatorAction = (permission) => async (dispatch) => {
  dispatch({ type: actionTypes.MODIFY });
  try {
    let response = await updateAccumulatorsSettingsAPI(permission);

    let data = response.data && response.data.result;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.MODIFY_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.MODIFY_FULFILLED,
      payload: { data },
    });

    dispatch(openSnackbarAction({ msg: getLocalizedString("accumulatorUpdatedOk"), severity: "success" }));
    return response;
  } catch (e) {
    if(e.response.data.error === "DUPLICATED_DATA"){
      dispatch(openSnackbarAction({ msg: getLocalizedString("cannotExistMoreThanOneAccumulatorWithSameCodeOrName"), severity: "error" }));
    }else{
      errorHandler(e, dispatch);
    }
    dispatch({ type: actionTypes.MODIFY_REJECTED, payload: e });
  }
};